import { createFileRoute } from '@tanstack/react-router';

import { UsersView } from '../../administracja/UsersView';

export const Route = createFileRoute('/administracja/uzytkownicy')({
  component: UsersView,
});
